export const utf8ToGsm0338 = (utf8: string): string => {
  const regex = /â|ê|ô|€/gi
  let result = utf8
  if (regex.test(utf8)) {
    result = utf8.replace(regex, '')
  }
  return result
}
